import * as React from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import { EnvironmentValidator } from "./components/EnvironmentValidator.tsx";
import { screenReaderAnnouncements } from "./lib/screen-reader-announcements";
import "./index.css";

// Make React globally available to prevent forwardRef errors
(window as any).React = React;

// Initialize screen reader announcements
screenReaderAnnouncements.init();

// Global error handler for production debugging
if (import.meta.env.PROD) {
  window.addEventListener('error', (event) => {
    console.error("Global error:", event.message, event.filename, event.lineno);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error("Unhandled promise rejection:", event.reason);
  });
}

const root = createRoot(document.getElementById("root")!);
root.render(
  <EnvironmentValidator>
    <App />
  </EnvironmentValidator>
);
